import { z } from 'zod'

export const unsophisticatedInvestorAnalysisFormSchema = z.object({
  isAgreedToTermsChecked: z.boolean().refine((val) => val === true, {
    message: 'Označte prosím, že súhlasíte s podmienkami rámcovej zmluvy.',
  }),
})

export type UnsophisticatedInvestorAnalysisFormSchema = z.infer<
  typeof unsophisticatedInvestorAnalysisFormSchema
>
